import { useMutation } from '@tanstack/react-query';
import {
  handleResponseSuccess,
  handleResponseThrowError,
} from '@/_utils/services';
import { apiClient } from '@/_config/lib/axios/api-client';

interface PutUpdateIsCloudParams {
  cityId: string;
  isCloud: boolean;
}

const putUpdateIsCloud = async ({ cityId, isCloud }: PutUpdateIsCloudParams) =>
  apiClient
    .put(`/municipios/${cityId}/is-cloud`, { isCloud })
    .then(response =>
      handleResponseSuccess(
        response,
        'Cadastro Nuvem atualizado com sucesso!',
      )(),
    )
    .catch(
      handleResponseThrowError('Não foi possível atualizar o cadastro Nuvem.'),
    );

export const useUpdateIsCloud = () => {
  return useMutation({
    mutationFn: putUpdateIsCloud,
  });
};
